import { DataModel } from "../../base/index.js";
import { MySql, Redis } from "../../database/index.js";
import type { AppLinkedDatabaseData } from "./types.js";

export class AppLinkedDatabase extends DataModel<AppLinkedDatabaseData> {
  public readonly database: MySql | Redis;
  public readonly isPrimary: boolean;
  public readonly id: string;

  public constructor(data: AppLinkedDatabaseData) {
    super(data);
    this.database =
      data.kind === "redis"
        ? Redis.ofId(data.databaseId)
        : MySql.ofId(data.databaseId);
    this.isPrimary = data.purpose === "primary";
    this.id = data.databaseId;
  }
}
